import React, { useEffect, useState, useContext, useMemo } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';
import Pagination from 'react-paginate';

const ProductPagination = ({
  arrProducts,
  selectedCategory,
  setCurrentPage,
  currentPage,
}) => {
  let navigate = useNavigate();
  const [productsPerPage] = useState(5);
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { product, fetchStatus, setFetchStatus } = contextState;

  const PER_PAGE = 6;
  const offset = currentPage * PER_PAGE;
  const currentPageData = arrProducts
    .slice(offset, offset + PER_PAGE)
    .map((el) => {
      return el;
    });
  const pageCount = Math.ceil(arrProducts.length / PER_PAGE);

  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const handleDetail = (event) => {
    const id = event.target.getAttribute('data-item');
    navigate(`/products/${id}`);
    setFetchStatus(true);
  };
  const renderText = (str) => {
    return str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  };
  return (
    <div className="row">
      {currentPageData.length !== 0 ? (
        currentPageData.map((el) => (
          <div className="col-lg-2 col-md-6 g-4" key={el._id}>
            <div className="card product-card g-5">
              {el.img[0] === undefined ? (
                <img
                  onClick={handleDetail}
                  data-item={el._id}
                  src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg"
                  className="card-img-top"
                  alt={el.nama_produk}
                />
              ) : (
                <img
                  onClick={handleDetail}
                  data-item={el._id}
                  src={el.img[0]}
                  className="card-img-top"
                  alt={el.nama_produk}
                />
              )}
              <div className="card-body">
                <p
                  onClick={handleDetail}
                  data-item={el._id}
                  className="card-text text-center text-link fw-bold fs-5"
                >
                  {el.nama_produk}
                </p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>Tidak ada produk berkategori {renderText(selectedCategory)}</p>
      )}
      <div className="product-pagination">
        <Pagination
          pageCount={pageCount}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          onPageChange={handlePageClick}
          activeClassName="active"
          previousLabel={'← Previous'}
          nextLabel={'Next →'}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
        />
      </div>
      {/* {currentPageData} */}
    </div>
  );
};

export default ProductPagination;
